/**
 * Fetches domain based on the domain id that is provided via route query, sets a local data variable
 * with fetched domain data.
 */
import { formErrorMessage } from "@/utility/formErrorMessage";

export default {
  data() {
    return {
      selectedDomainInfo: {},
      providedDomainId: this.$route?.query?.domainId || "",
      isDomainProvided: false,
    };
  },

  async beforeMount() {
    if (!this.providedDomainId) return;
    try {
      this.isDomainProvided = true;
      const domainData = await this.getDomainData(this.providedDomainId);
      this.form.domain = domainData["@id"];
      // If form has a menu, assign domain to it as well
      this.form.menu && (this.form.menu.domain = domainData["@id"]);

      this.selectedDomainInfo = domainData;
    } catch (err) {
      this.isDomainProvided = false;
    }
  },

  methods: {
    async getDomainData(domainId) {
      try {
        const { data } = await this.$admin.dataProvider.getOne("domains", {
          id: domainId,
        });

        return data;
      } catch (err) {
        this.$admin.toast.error(formErrorMessage(err, this.$t("error")));
      }
    },
  },
};
